import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReferenceTypeList from "../pages/ReferenceType/ReferenceTypeList";
import CreateReferenceType from "../pages/ReferenceType/CreateReferenceType";
import EditReferenceType from "../pages/ReferenceType/EditReferenceType";


export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<ReferenceTypeList />} />
          <Route path="/reference-type" element={<ReferenceTypeList />} />
          <Route path="/create" element={<CreateReferenceType />} />
          <Route path="/edit/:id" element={<EditReferenceType />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;